const ErrorString: React.FC<{ error: string }> = ({ error }) => {
    return <div style={{ marginLeft: 7, fontSize: 15, color: 'tomato' }}>{error}</div>;
};

export default ErrorString;
